import { useContext } from 'react';
import { GroupTagsUpdateContext } from '../Context';

export default function useGroupTagsUpdate() {
  const value = useContext(GroupTagsUpdateContext);
  return value;
}

export { useGroupTagsUpdate };